import { IDataType, SisDataGridColumns } from '../../components/table';

export const Columns: SisDataGridColumns = [
  {
    dataField: 'id',
    dataType: IDataType.number,
    caption: 'Status id',
    width: '5%',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '88%',
    caption: 'Name',
  },
  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '7%',
  },
];
